class Customer.ResponseTemplate extends Backbone.Model

  urlRoot: '/keepcon/settings/user_setting/response_templates'

  defaults:
    'template_types': []
    'active': true
    'private_reply_for_public_contents': false
    'assign_to_operator_id': false
    'chatbot_code': ''
    'template_type': 'plain'
    'intelligent_filter': {
      'intelligent_tags': {
        'main_tags': []
        'secondary_tags': []
        'excluded_tags': []
        'main_tags_logic': 'OR'
        'secondary_tags_logic': 'OR'
        'excluded_tags_logic': 'OR'
      }
      'intelligent_groups': {
        'main_groups': []
        'secondary_groups': []
        'excluded_groups': []
        'main_groups_logic': 'OR'
        'secondary_groups_logic': 'OR'
        'excluded_groups_logic': 'OR'
      }
    }

  parse: (resp) ->
    resp['template_types'] = _.pluck(resp.template_types, 'id')
    resp['template_tags_attributes'] = resp['template_tags']
    resp['template_labels_attributes'] = resp['template_labels']
    delete resp['template_labels']
    delete resp['template_tags']
    resp

  isActive: ->
    !!@get('active')

  tagsLogic: ->
    @get('tags_logic')

  tagsLogicIsAnd: ->
    @get('tags_logic') == "AND"

  isHTML: =>
    @get('template_type') == 'html'

  enhancedText: ->
    @get('template')
      .replace(/\{\{user\}\}/g, '<span class="template-placeholder">{{user}}</span>')
      .replace(/\{\{date\}\}/g, '<span class="template-placeholder">{{date}}</span>')
      .replace(/\{\{ticket_id\}\}/g, '<span class="template-placeholder">{{ticket_id}}</span>')
      .replace(/\{\{@user\}\}/g, '<span class="template-placeholder">{{@user}}</span>')

  replacedText: (user, date, ticketId, username) ->
    @get('template')
      .replace(/\{\{user\}\}/g, user)
      .replace(/\{\{date\}\}/g, date || (new Date()).format())
      .replace(/\{\{ticket_id\}\}/g, ticketId)
      .replace(/\{\{@user\}\}/g, username || '')

  intelligentTagsList: ->
    tags = @get('intelligent_filter').intelligent_tags
    if tags && tags.main_tags
      tags.main_tags.concat(tags.secondary_tags, tags.excluded_tags)
    else
      []

  intelligentGroupsList: ->
    groups = @get('intelligent_filter').intelligent_groups
    if groups && groups.main_groups
      groups.main_groups.concat(groups.secondary_groups, groups.excluded_groups)
    else
      []

  isFromClient: ->
    @get('setting_type') == 'Keepcon::Settings::UserSetting'

  isFromAccount: ->
    @get('setting_type') == 'Keepcon::Settings::AccountSetting'

  isOrTagsLogic: ->
    @get('tags_logic') == 'OR'

  isForType: (typeName, types) ->
    _.chain(types)
      .filter (type) => _.contains(@get('template_types'), type.id)
      .pluck('name')
      .contains(typeName)
      .value()

  isOnlyForSpecificTypes: ->
    @get('template_types').length > 0

  isOnlyForChatbotAssignation: ->
    _.isNumber(@get('assign_to_operator_id'))

  _matchWithLogic: (content_names, filter_names, logic, empty_filter_names_criteria) ->
    return empty_filter_names_criteria if _.isEmpty(filter_names)
    criteria = if logic == 'AND' then _.all else _.any

    return criteria filter_names, (name) ->
      _.contains(content_names, name)

  _matchesIntelligentElement: (filterName, interactionElements) ->
    return false if _.isEmpty(interactionElements)

    filter = @get('intelligent_filter')["intelligent_#{filterName}"]
    matchesMain = @_matchWithLogic(interactionElements, filter["main_#{filterName}"], filter["main_#{filterName}_logic"], false)
    matchesSecondary = @_matchWithLogic(interactionElements, filter["secondary_#{filterName}"], filter["secondary_#{filterName}_logic"], true)

    excludedNames = filter["excluded_#{filterName}"]
    if excludedNames && !_.isEmpty(excludedNames)
      matchesExcluded = !@_matchWithLogic(interactionElements, filter["excluded_#{filterName}"], filter["excluded_#{filterName}_logic"], true)
    else
      matchesExcluded = true

    matchesMain && matchesSecondary && matchesExcluded

  matchesIntelligentTags: (interactionTags) ->
    @_matchesIntelligentElement('tags', interactionTags)

  matchesIntelligentLabels: (interactionLabels) ->
    @_matchesIntelligentElement('groups', interactionLabels)

class Customer.ResponseTemplateContext
  constructor: (context = 'client') ->
    @context = context == 'account'
    @

  isAccount: =>
    @context

  isClient: =>
    !@context

  toS: =>
    if @isAccount() then 'account' else 'client'
